<template>
    <transition-group name="fade" mode="out-in" tag="div" id="itb-slides">
        <div v-if="image" class="itb-slide-parent" :key="image.id">
            <div class="itb-slide-image" :style="setBackgroundImage">
                <div class="itb-slide-wrapper">
                    <div class="itb-slide-title">
                        {{ image.title }}
                    </div>
                    <div
                        v-html="image.content"
                        class="itb-slider-description"
                    ></div>
                </div>
            </div>
        </div>
    </transition-group>
</template>

<script>
export default {
    props: ["image"],
    computed: {
        setBackgroundImage() {
            return { backgroundImage: "url(" + this.image.image + ")" };
        },
    },
};
</script>

<style lang="scss">
$animation-zoom-duration: 6s;
$fontsize-slidetext: 40px;
$dark-grey: #5b5b5b;
$darker-grey: #363535;
$white: #fff;
$font-weight-regular: 500;
$font-weight-bold: 700;

@media (max-width: 768px) {
    #itb-slides .itb-slide-parent .itb-slide-image .itb-slide-wrapper {
        width: 100% !important;
    }
}

#itb-slides {
    height: inherit;
    width: inherit;

    .itb-slide-parent {
        width: 100%;
        height: 522px;

        .itb-slide-image {
            height: 100%;
            width: 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            padding-top: 2rem;
            padding-left: 2rem;
            padding-right: 2rem;

            .itb-slide-wrapper {
                background: rgb($white, 60%);
                padding: 1rem 2rem 2rem;

                .itb-slide-title {
                    font-size: 1.625rem;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    color: $darker-grey;
                    font-weight: $font-weight-bold;
                    padding: 0 0 4px;
                }

                .itb-slider-description {
                    line-height: 2rem;
                    color: $dark-grey;
                    font-weight: $font-weight-regular;
                }

                .itb-slider-link {
                    margin-top: 38px;

                    a {
                        font-size: 1.125rem;
                        line-height: 1.5rem;
                        color: $darker-grey;
                        font-weight: $font-weight-regular;
                        text-decoration: none;

                        span {
                            position: relative;

                            &:after {
                                content: "";
                                width: 100%;
                                height: 2px;
                                background-color: $darker-grey;
                                position: absolute;
                                bottom: -2px;
                                left: 0;
                            }
                        }

                        i {
                            font-size: 1.6rem;
                            top: 6px;
                            position: relative;
                        }
                    }
                }
            }
        }
    }
}

.fade-enter-active {
    animation-name: fadeEnter;
    animation-duration: 1s;
    animation-iteration-count: 1;
}

.fade-move {
    transition: all 1s;
}

.fade-leave-active {
    animation-name: fadeLeave;
    animation-duration: 1s;
    animation-iteration-count: 1;
    position: absolute;
}

@keyframes zoom {
    from {
        transform: scale(1);
    }
    to {
        transform: scale(1.1);
    }
}

@keyframes fadeEnter {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeLeave {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
</style>
